export default __webpack_public_path__ + "static/media/03.9a2c19de.png";